import { Row } from 'react-bootstrap'
import React, { useContext } from 'react'
import {
  EditorContext,
  EditorContextType,
} from '@editor/components/editorContext'

const JobDetail = () => {
  const { article, job } = useContext(EditorContext) as EditorContextType
  return (
    <>
      <Row>
        <h4 className="fw-bold">{article?.title}</h4>
      </Row>
      <div
        style={{fontSize: '13px'}}
        className="d-flex justify-content-between flex-row w-100 mb-3"
      >
        <span className="p-0 m-0">
          <span className="text-secondary">ID:</span> {job?.id}
        </span>
        <span className="p-0 m-0">
          <span className="text-secondary">ID článku:</span> {article?.articleId}
        </span>
        <span className="p-0 m-0">
          <span className="text-secondary">Autor:</span> {article?.author}
        </span>
        <span className="p-0 m-0">
          {article && article.datePublished ? (
            <span className="text-secondary">
              Publikace: {new Date(article.datePublished).toLocaleString()}
            </span>
          ) : (
            ''
          )}
        </span>
        <span className="p-0 m-0">
          {article &&
          article.latest_version &&
          article.latest_version.dateModified ? (
            <span className="text-secondary">
              Editováno:{' '}
              {new Date(article.latest_version.dateModified).toLocaleString()}
            </span>
          ) : (
            ''
          )}
        </span>
      </div>
    </>
  )
}

export default JobDetail
